/** Resolve total secret-word rounds from WS/REST payloads (snake_case + short + camel aliases). */
export function imposterOnlineSessionRoundTotal(
  game: Record<string, unknown> | null | undefined,
): number {
  if (!game || typeof game !== "object") return 1;
  const candidates = [
    game.session_round_total,
    game.word_round_total,
    game.sessionRoundTotal,
    game.wordRoundTotal,
  ];
  for (const c of candidates) {
    if (typeof c === "number" && Number.isFinite(c) && c > 0) return Math.floor(c);
    if (typeof c === "string" && /^\d+$/.test(c.trim())) {
      const n = parseInt(c.trim(), 10);
      if (n > 0) return n;
    }
  }
  return 1;
}
